import { defer } from 'rxjs';
import { tap, finalize } from 'rxjs/operators';
export var FinalizeReason;
(function (FinalizeReason) {
    FinalizeReason["Unsubscribe"] = "unsubscribe";
    FinalizeReason["Complete"] = "complete";
    FinalizeReason["Error"] = "error";
})(FinalizeReason || (FinalizeReason = {}));
export var finalizeWithReason = function (callback) {
    return function (source) {
        return defer(function () {
            var completed = false;
            var errored = false;
            return source.pipe(tap({
                error: function () { return errored = true; },
                complete: function () { return completed = true; },
            }), finalize(function () {
                if (errored) {
                    callback(FinalizeReason.Error);
                }
                else if (completed) {
                    callback(FinalizeReason.Complete);
                }
                else {
                    callback(FinalizeReason.Unsubscribe);
                }
            }));
        });
    };
};
//# sourceMappingURL=finalizeWithReason.js.map